import axios from 'axios';
import { ButtonGroup, ComboBox, DataGrid, Dialog, Form, FormField, GridColumn, Label, Layout, LayoutPanel, LinkButton, Panel, TextBox } from 'rc-easyui';
import React, { Component } from 'react';
import { uAPIlocal } from '../../lib/config';
import Loader from 'react-loader-spinner';
import {
    Row,
    Col,
} from "react-bootstrap";

class MasterKonsultasi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            master_konsultasi: {
                total: 0,
                pageSize: 20,
                data: [],
                pagePosition: "bottom",
                pageOptions: {
                    layout: ['list', 'sep', 'first', 'prev', 'next', 'last', 'sep', 'refresh', 'sep', 'manual', 'info']
                },
                selection: null,
                loading: true,
            },
            formTambah: {
                field: {
                    NAMA_KONSULTASI: "",
                    KATEGORI_KONSULTASI: "",
                    HARGA_KONSULTASI: "",
                    KODE_KONSULTASI: "",
                },
                rules: {
                    NAMA_KONSULTASI: ["required"],
                    KATEGORI_KONSULTASI: ["required"],
                    HARGA_KONSULTASI: ["required"],
                    KODE_KONSULTASI: ["required"],
                }
            },
            formEdit: {
                field: {
                    NAMA_KONSULTASI: "",
                    KATEGORI_KONSULTASI: "",
                    HARGA_KONSULTASI: "",
                    KODE_KONSULTASI: "",
                    branch_code: "",
                },
                rules: {
                    NAMA_KONSULTASI: ["required"],
                    KATEGORI_KONSULTASI: ["required"],
                    HARGA_KONSULTASI: ["required"],
                    KODE_KONSULTASI: ["required"],
                }
            },
            loader: false,
        }
        this.errorDialog = React.createRef();
        this.tambahConc = React.createRef();
        this.editConc = React.createRef();

        this.pageChange = this.pageChange.bind(this);
        this.selectionChange = this.selectionChange.bind(this);

        this.formTambah = React.createRef();
        this.handleChangeFormTambah = this.handleChangeFormTambah.bind(this);
        this.handleSubmitFormTambah = this.handleSubmitFormTambah.bind(this);

        this.formEdit = React.createRef();
        this.handleEditClick = this.handleEditClick.bind(this)
        this.handleChangeformEdit = this.handleChangeformEdit.bind(this);
        this.handleSubmitformEdit = this.handleSubmitformEdit.bind(this);

        this.removeDialog = React.createRef();
        this.removedData = this.removedData.bind(this);
        this.handleRemoveClick = this.handleRemoveClick.bind(this);
        this.getBranch = this.getBranch.bind(this);
    }

    async getData() {
        await axios.post(uAPIlocal + '/api/v1/konsultasi')
            .then(function (response) {
                return response.data.results;
            })
            .then(response => {
                // console.log(response)
                this.setState({
                    master_konsultasi: {
                        ...this.state.master_konsultasi,
                        data: response,
                        loading: false
                    }
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async getBranch() {
        await axios.post(uAPIlocal + `/api/v1/branch`)
            .then(response =>
                // console.log("ini Branch",response),
                response.data.results.map(item => ({
                    value: `${item.branch_code}`,
                    text: `${item.branch_name}`,
                }))
            )
            .then(Branch => {
                this.setState({
                    Branch: Branch,
                    chooseBranch: Branch[0],
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    changeSelectBranch = (e) => {
        this.setState({ chooseBranch: e })
    }

    pageChange(event) {
        // console.log(event)
        if (event.refresh) {
            // console.log(event)
            this.setState({
                master_konsultasi: {
                    ...this.state.master_konsultasi,
                    loading: true,
                    selection: null
                },
            })
            this.getData();
        }

    }
    async selectionChange(event) {
        // console.log(event)
        let indexBranch = this.state.Branch.findIndex(function (item, i) {
            return item.value == event.branch_code
        });
        await this.setState({
            master_konsultasi: {
                ...this.state.master_konsultasi,
                selection: event
            },
            chooseBranch: this.state.Branch[indexBranch],
        })
    }

    async handleChangeFormTambah(name, value) {
        let field = Object.assign({}, this.state.formTambah.field);
        field[name] = value;
        await this.setState({
            formTambah: {
                ...this.state.formTambah,
                field: field
            }
        }, () => console.log(this.state.formTambah.field))
    }

    async handleSubmitFormTambah() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const NAMA_KONSULTASI = this.state.formTambah.field.NAMA_KONSULTASI;
        const KATEGORI_KONSULTASI = this.state.formTambah.field.KATEGORI_KONSULTASI;
        const HARGA_KONSULTASI = this.state.formTambah.field.HARGA_KONSULTASI;
        const KODE_KONSULTASI = this.state.formTambah.field.KODE_KONSULTASI;
        formData.append('NAMA_KONSULTASI', NAMA_KONSULTASI);
        formData.append('KATEGORI_KONSULTASI', KATEGORI_KONSULTASI);
        formData.append('HARGA_KONSULTASI', HARGA_KONSULTASI);
        formData.append('KODE_KONSULTASI', KODE_KONSULTASI);
        formData.append('branch_code', this.state.chooseBranch);

        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        if (NAMA_KONSULTASI == '' || KATEGORI_KONSULTASI == '' || HARGA_KONSULTASI == '' || KODE_KONSULTASI == '') {

            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();

        } else if (KODE_KONSULTASI.length > 2) {

            this.setState({
                errorMessage: "Kode poli maksimal 2 Karakter!",
            })
            this.errorDialog.current.open();
        } else {
            await axios.post(uAPIlocal + '/api/v1/master_konsultasi', formData, config)
                .then(response => {
                    // console.log(response)
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.getData();
                        this.tambahConc.current.close();
                        this.setState({
                            formTambah: {
                                ...this.state.formTambah,
                                field: {
                                    NAMA_KONSULTASI: "",
                                    KATEGORI_KONSULTASI: "",
                                    HARGA_KONSULTASI: "",
                                    KODE_KONSULTASI: "",
                                },
                            },
                            chooseBranch: this.state.Branch[0],
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

    }

    async handleRemoveClick() {
        if (this.state.master_konsultasi.selection) {
            this.removeDialog.current.open();
        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async removedData() {
        await this.setState({
            loader: true
        })
        const id = this.state.master_konsultasi.selection.ID_KONSULTASI
        await axios.delete(uAPIlocal + `/api/v1/master_konsultasi/${id}`)
            .then(function (response) {
                // console.log(response)this.state.pasien.selection.id_regis
                return response.data;
            })
            .then(response => {
                // console.log(response)
                this.getData();
                this.removeDialog.current.close();
                this.setState({
                    loader: false,
                    master_konsultasi: {
                        ...this.state.master_konsultasi,
                        selection: null
                    },
                })




            })
            .catch(error => {
                console.log(error);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    if (error.response.status === 500) {
                        this.setState({
                            loader: false,
                            errorMessage: error.response.data,
                        })
                        this.errorDialog.current.open();
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // console.log(error.request);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                } else {
                    // Something happened in setting up the request that triggered an Error
                    // console.log('Error', error.message);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                }

            });
    }

    async handleEditClick() {
        if (this.state.master_konsultasi.selection) {
            console.log(this.state.master_konsultasi.selection)
            const NAMA_KONSULTASI = `${this.state.master_konsultasi.selection.NAMA_KONSULTASI}`
            const KATEGORI_KONSULTASI = `${this.state.master_konsultasi.selection.KATEGORI_KONSULTASI}`
            const HARGA_KONSULTASI = `${this.state.master_konsultasi.selection.HARGA_KONSULTASI}`
            const KODE_KONSULTASI = `${this.state.master_konsultasi.selection.KODE_KONSULTASI}`

            await this.setState({
                formEdit: {
                    ...this.state.formEdit,
                    field: {
                        NAMA_KONSULTASI: NAMA_KONSULTASI,
                        KATEGORI_KONSULTASI: KATEGORI_KONSULTASI,
                        HARGA_KONSULTASI: HARGA_KONSULTASI,
                        KODE_KONSULTASI: KODE_KONSULTASI,
                    },
                },
            })

            this.editConc.current.open();
        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async handleChangeformEdit(name, value) {
        let field = Object.assign({}, this.state.formEdit.field);
        field[name] = value;
        await this.setState({
            formEdit: {
                ...this.state.formEdit,
                field: field
            }
        })
    }
    async handleSubmitformEdit() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const NAMA_KONSULTASI = this.state.formEdit.field.NAMA_KONSULTASI;
        const KATEGORI_KONSULTASI = this.state.formEdit.field.KATEGORI_KONSULTASI;
        const HARGA_KONSULTASI = this.state.formEdit.field.HARGA_KONSULTASI;
        const KODE_KONSULTASI = this.state.formEdit.field.KODE_KONSULTASI;
        formData.append('ID_KONSULTASI', this.state.master_konsultasi.selection.ID_KONSULTASI);
        formData.append('NAMA_KONSULTASI', NAMA_KONSULTASI);
        formData.append('KATEGORI_KONSULTASI', KATEGORI_KONSULTASI);
        formData.append('KODE_KONSULTASI', KODE_KONSULTASI)
        formData.append('HARGA_KONSULTASI', HARGA_KONSULTASI);
        formData.append('branch_code', this.state.chooseBranch);

        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        if (NAMA_KONSULTASI == '' || KATEGORI_KONSULTASI == '' || HARGA_KONSULTASI == '' || KODE_KONSULTASI == '') {

            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();

        } else {

            await axios.put(uAPIlocal + '/api/v1/master_konsultasi', formData, config)
                .then(response => {
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.setState({
                            master_konsultasi: {
                                ...this.state.master_konsultasi,
                                loading: true
                            }
                        })
                        this.getData();
                        this.editConc.current.close();
                        this.setState({
                            formEdit: {
                                ...this.state.formEdit,
                                field: {
                                    NAMA_KONSULTASI: "",
                                    KATEGORI_KONSULTASI: "",
                                    HARGA_KONSULTASI: "",
                                    KODE_KONSULTASI: "",
                                },
                            },
                            chooseBranch: this.state.Branch[0],
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        }

    }

    componentDidMount() {
        this.getData();
        this.getBranch()
    }
    componentWillUnmount() {
        window.location.reload();
    }
    render() {
        return (

            <Row>


                <Dialog
                    title="Alert"
                    style={{ width: '300px', height: '84px' }}
                    modal
                    closed={true}
                    ref={this.errorDialog}
                >
                    <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>{this.state.errorMessage}</p>
                </Dialog>

                <Dialog title="Tambah Konsultasi"
                    style={{ width: '500px', }}
                    modal
                    closed={true}
                    ref={this.tambahConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formTambah}
                            style={{ maxWidth: 500 }}
                            model={this.state.formTambah.field}
                            rules={this.state.formTambah.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeFormTambah}
                        >
                            <FormField name="NAMA_KONSULTASI" label="NAMA KONSULTASI">
                                {/* <ComboBox data={this.state.Test_Code} value={this.state.formTambah.field.Test_ID} ></ComboBox> */}
                                <TextBox inputId="t1" name="ftestid" value={this.state.formTambah.field.NAMA_KONSULTASI} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="KATEGORI_KONSULTASI" label="KATEGORI POLI">
                                <TextBox inputId="t2" name="ftestname" value={this.state.formTambah.field.KATEGORI_KONSULTASI} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="KODE_KONSULTASI" label="KODE KONSULTASI / POLI">
                                <TextBox inputId="t4" name="fconcid" value={this.state.formTambah.field.KODE_KONSULTASI} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="HARGA_KONSULTASI" label="HARGA KONSULTASI / POLI">
                                <TextBox inputId="t3" name="fconcid" value={this.state.formTambah.field.HARGA_KONSULTASI} style={{ width: '100%' }}></TextBox>
                            </FormField>


                            <FormField name="branch_code" label="BRANCH">
                                <ComboBox onChange={this.changeSelectBranch}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Branch} value={this.state.chooseBranch} ></ComboBox>
                            </FormField>


                            <FormField >
                                <LinkButton onClick={this.handleSubmitFormTambah} >Submit</LinkButton>
                            </FormField>
                        </Form>
                    </div>
                </Dialog>

                <Dialog title="Edit Konsultasi"
                    style={{ width: '500px', }}
                    modal
                    closed={true}
                    ref={this.editConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formEdit}
                            style={{ maxWidth: 500 }}
                            model={this.state.formEdit.field}
                            rules={this.state.formEdit.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeformEdit}
                        >
                            <FormField name="NAMA_KONSULTASI" label="NAMA KONSULTASI">
                                <TextBox inputId="t1" name="ftestid" value={this.state.formEdit.field.NAMA_KONSULTASI} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="KATEGORI_KONSULTASI" label="KATEGORI POLI">
                                <TextBox inputId="t2" name="ftestname" value={this.state.formEdit.field.KATEGORI_KONSULTASI} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="KODE_KONSULTASI" label="KODE KONSULTASI / POLI">
                                <TextBox inputId="t4" name="fconcid" value={this.state.formEdit.field.KODE_KONSULTASI} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="HARGA_KONSULTASI" label="HARGA KONSULTASI / POLI">
                                <TextBox inputId="t3" name="fconcid" value={this.state.formEdit.field.HARGA_KONSULTASI} style={{ width: '100%' }}></TextBox>
                            </FormField>

                            <FormField name="branch_code" label="BRANCH">
                                <ComboBox onChange={this.changeSelectBranch}
                                    // disabled={true}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Branch} value={this.state.chooseBranch} ></ComboBox>
                            </FormField>
                            <FormField >
                                <LinkButton onClick={this.handleSubmitformEdit} >Submit</LinkButton>
                            </FormField>
                        </Form>
                    </div>
                </Dialog>
                <Dialog
                    title="Please Confirm"
                    style={{ width: '300px', height: '190px' }}
                    modal
                    closed={true}
                    ref={this.removeDialog}
                    footer={() => {
                        return (
                            this.state.loader ? (
                                <div className="text-center">
                                    <Loader type="TailSpin" color="#00BFFF" height={40} width={100} />
                                </div>
                            ) : (

                                <>
                                    <ButtonGroup style={{ width: '100%', height: '50px' }}>
                                        <LinkButton className="f-full mybtn" plain onClick={this.removedData}>Yakin</LinkButton>
                                        <LinkButton className="f-full mybtn" plain onClick={() => this.removeDialog.current.close()}>Cancel</LinkButton>
                                    </ButtonGroup>
                                </>
                            )
                        )
                    }}

                >
                    <>
                        <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>Apakah Anda Yakin ?</p>

                    </>
                </Dialog>


                <Col md="12" style={{ backgroundColor: "white", padding: "2px" }}>
                    <Panel
                        title="Master Konsultasi"
                        collapsible
                    // bodyStyle={{ padding: 20 }}
                    // style={{ height: 500 }}
                    >
                        <Row style={{ padding: 0, marginBottom: 4, marginLeft: 2 }}>
                            <Col className="col-8">
                                <div style={{ marginTop: 10, marginLeft: 4 }}>
                                    <LinkButton
                                        iconCls="icon-add"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.addRow()}
                                        onClick={() => this.tambahConc.current.open()}
                                    >
                                        Tambah
                                    </LinkButton>
                                    <LinkButton
                                        iconCls="icon-edit"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.editRow()}
                                        onClick={this.handleEditClick}
                                        disabled={this.state.master_konsultasi.selection ? false : true}
                                    >
                                        Ubah
                                    </LinkButton>
                                    <LinkButton
                                        iconCls="icon-cancel"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.deleteRow()}
                                        onClick={this.handleRemoveClick}
                                        disabled={this.state.master_konsultasi.selection ? false : true}
                                    >
                                        Hapus
                                    </LinkButton>
                                </div>
                            </Col>
                        </Row>

                        <div id="DataGrid">
                            <DataGrid
                                {...this.state.master_konsultasi}
                                style={{ height: '70vh', }}
                                pagination
                                columnResizing
                                selectionMode="single"
                                onSelectionChange={this.selectionChange}
                                // onPageChange={this.pageChange}
                                filterable
                                virtualScroll
                                columnMoving
                            >
                                {/* <GridColumn
                                    field="rn"
                                    align="center"
                                    width="30px"
                                    cellCss="datagrid-td-rownumber"
                                    render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
                                    filterable={false}
                                /> */}
                                {/* <GridColumn
                                    field="ID_KONSULTASI"
                                    title="ID"
                                    align="center"
                                    width="40px"
                                ></GridColumn> */}
                                <GridColumn
                                    sortable
                                    field="NAMA_KONSULTASI"
                                    title="NAMA KONSULTASI"
                                    align="center"
                                    width="100px"
                                ></GridColumn>
                                <GridColumn
                                    field="KATEGORI_KONSULTASI"
                                    title="KATEGORI"
                                    align="center"
                                    width="80px"
                                ></GridColumn>
                                <GridColumn
                                    field="KODE_KONSULTASI"
                                    title="KODE"
                                    align="center"
                                    width="40px"
                                ></GridColumn>
                                <GridColumn
                                    field="HARGA_KONSULTASI"
                                    title="HARGA"
                                    align="center"
                                    width="100px"
                                ></GridColumn>
                                <GridColumn
                                    field="branch_name"
                                    title="CABANG"
                                    // hidden="true"
                                    align="center"
                                    width="100px"
                                ></GridColumn>
                            </DataGrid>
                        </div>
                    </Panel>
                </Col>
            </Row>
        )
    }
}
export default MasterKonsultasi